import Loader from 'apollo-react/components/Loader';
import Modal from 'apollo-react/components/Modal';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { useTranslation } from '../../../custom-hooks/useTranslation';
import { recreateTemplates } from '../../actions/entity-designer.actions';

const RecreateTemplatesConfirmationModal = ({ isOpen, setIsOpen }) => {
  const dispatch = useDispatch();
  const translateString = useTranslation();

  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => setIsOpen(false);

  const handleOk = async () => {
    setIsLoading(true);
    await dispatch(recreateTemplates());
    handleClose();
    setIsLoading(false);
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      title={translateString('Confirm Operation')}
      variant="warning"
      disableBackdropClick
      disableEscapeKeyDown
      buttonProps={[
        {
          label: translateString('Cancel'),
          variant: 'text',
          onClick: handleClose,
        },
        {
          label: translateString('Ok'),
          variant: 'primary',
          onClick: handleOk,
        },
      ]}
    >
      <p>
        {translateString(
          'All existing templates for this Entity will be overwritten. Are you sure you want to recreate the template files?'
        )}
      </p>
      {isLoading && <Loader isInner />}
    </Modal>
  );
};

export default RecreateTemplatesConfirmationModal;
